module.exports = __webpack_public_path__ + "img/pt.1ce44ae5.svg";